import React, { useState, useEffect, useContext } from "react";
import { certificatesAPI } from "../../lib/apiService";
import { APIRequestContext } from "../../context";

function UserDashboard() {
  const [myCertificates, setMyCertificates] = useState([]);
  const { request_handler } = useContext(APIRequestContext);

  useEffect(() => {
    loadMyCertificates();
  }, []);

  const loadMyCertificates = () => {
    request_handler(async () => {
      const response = await certificatesAPI.getMyCertificates();
      setMyCertificates(response.data || response);
      return { data: { message: "Your certificates loaded successfully" } };
    });
  };

  const downloadCertificate = (certificateUrl, fileName) => {
    const link = document.createElement('a');
    link.href = certificateUrl;
    link.download = fileName || 'certificate.png';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="user-dashboard">
      <h1>My Certificates</h1>
      
      {myCertificates.length === 0 ? (
        <div className="no-certificates">
          <p>You don't have any certificates yet.</p>
        </div>
      ) : (
        <div className="certificates-grid">
          {myCertificates.map((cert) => (
            <div key={cert.id} className="certificate-card">
              <div className="certificate-header">
                <h3>{cert.name}</h3>
                <span className="certificate-id">ID: {cert.id}</span>
              </div>
              
              <div className="certificate-details">
                <p><strong>Event:</strong> {cert.event}</p>
                <p><strong>Category:</strong> {cert.category}</p>
                <p><strong>Issue Date:</strong> {new Date(cert.created_at).toLocaleDateString()}</p>
              </div>
              
              {cert.certificate_url && (
                <div className="certificate-preview">
                  <img 
                    src={cert.certificate_url} 
                    alt={`Certificate for ${cert.name}`}
                    className="certificate-thumbnail"
                    style={{ 
                      width: "100%", 
                      maxHeight: "200px", 
                      objectFit: "contain",
                      border: "1px solid #ddd",
                      borderRadius: "4px"
                    }}
                  />
                </div>
              )}
              
              <div className="certificate-actions">
                {cert.certificate_url && (
                  <button
                    onClick={() => downloadCertificate(cert.certificate_url, `${cert.name}-certificate.png`)}
                    className="btn btn-primary"
                  >
                    Download Certificate
                  </button>
                )}
                
                <button
                  onClick={() => window.open(`/verify/${cert.id}`, '_blank')}
                  className="btn btn-secondary"
                >
                  Verify Certificate
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
      
      <style jsx>{`
        .certificates-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
          gap: 20px;
          margin-top: 20px;
        }
        
        .certificate-card {
          border: 1px solid #ddd;
          border-radius: 8px;
          padding: 20px;
          background: white;
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        }
        
        .certificate-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 15px;
          border-bottom: 1px solid #eee;
          padding-bottom: 10px;
        }
        
        .certificate-header h3 {
          margin: 0;
          color: #333;
        }
        
        .certificate-id {
          font-size: 0.9em;
          color: #666;
          background: #f5f5f5;
          padding: 2px 6px;
          border-radius: 4px;
        }
        
        .certificate-details {
          margin-bottom: 15px;
        }
        
        .certificate-details p {
          margin: 5px 0;
          color: #555;
        }
        
        .certificate-preview {
          margin: 15px 0;
        }
        
        .certificate-actions {
          display: flex;
          gap: 10px;
          flex-wrap: wrap;
        }
        
        .certificate-actions .btn {
          flex: 1;
          min-width: 120px;
        }
        
        .no-certificates {
          text-align: center;
          padding: 50px;
          color: #666;
        }
      `}</style>
    </div>
  );
}

export default UserDashboard;
